/* @flow */
import idx from 'idx';
import * as React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Button from 'components/Button.jsx';

type Props = {
  deviceId: number,
  resend: (id: number) => Promise<*>,
};

type State = {
  error: ?Error,
  resent: boolean,
  resending: boolean,
};

class PendingDeviceResendVerification extends React.Component<Props, State> {
  state: State = {
    error: null,
    resent: false,
    resending: false,
  };

  resend = () => {
    this.setState({ resending: true, error: null });

    this.props
      .resend(this.props.deviceId)
      .then(
        () => this.setState({ resending: false, resent: true }),
        error => this.setState({ resending: false, resent: false, error })
      );
  };

  render() {
    if (this.state.resent) {
      return <span>Verfication link was successfully resent.</span>;
    }

    if (this.state.error) {
      return <span>Oops, an error happened: {this.state.error.toString()}.</span>;
    }

    return (
      <Button disabled={this.state.resending} onClick={this.resend}>
        Resend verification link.
      </Button>
    );
  }
}

const RESEND_PENDING_SMS_DEVICE_VERIFICATION_NOTIFICATION = gql`
  mutation resendPendingSmsDeviceVerificationNotification($id: Int!) {
    resendPendingSmsDeviceVerificationNotification(id: $id) {
      error {
        message
        code
      }
    }
  }
`;

const withMutation = graphql(RESEND_PENDING_SMS_DEVICE_VERIFICATION_NOTIFICATION, {
  props: ({ mutate }) => ({
    resend: id => {
      return mutate({ variables: { id } }).then(response => {
        if (idx(response, _ => _.data.resendPendingSmsDeviceVerificationNotification.error)) {
          throw new Error(
            response.data.resendPendingSmsDeviceVerificationNotification.error.message
          );
        }
      });
    },
  }),
});

export { PendingDeviceResendVerification };
export default withMutation(PendingDeviceResendVerification);
